// @flow

export function addToCartVitaminExpress (customerId: string, subscriberId: string, productId: string): Promise<any> {
  if (window.chatBotAddProduct) {
    // TODO; Dominik; 01.12.2020; this is a workaround for multiple products with a separate ending
    return window.chatBotAddProduct(productId.split('_')[0], 1)
  } else {
    return window.addProductToCart(productId.split('_')[0], 1)
  }
}
